//CMå 20.11.2014
//Tämä tiedosto sisältää javascript funktioita joita käytetään yleisesti PRIS:ssä
//Requires Jquery
(function($){

	var gDependenciesLoaded = false;

	var head = document.getElementsByTagName("head")[0] || document.body;
	var script = document.createElement("script");

	script.src = "/javascript/deps.asp";
	script.type = "text/javascript";

	script.onreadystatechange = function () {
		if (this.readyState == 'complete' || this.readyState == 'loaded') {
			gDependenciesLoaded = true;
		}
	};

	script.onload = function() {
		gDependenciesLoaded = true;
	};

	head.appendChild(script);

	//Ajax helper funktioita
	Ajax = (function(){
		return {
			//Haetaan libAjaxFuncs kirjastosta json dataa.
			//Palauta promise
			fetch: function(func, inParams){

				var ajaxParams = ["async", "url", "dataType"];

				if(inParams.url && inParams.url.length > 0){
					//Jos annettu poikkeava url, ei tarvitse vaatia Func - parametria.
				}
				else{
					if(func === undefined){
						return;
					}

					if(func.length === 0){
						return;
					}
				}

				var dataobj = {
					FUNC: func,
					Dummy: new Date()
				};

				//Kopioidaan parametrit
				for (var prop in inParams) {
					if (inParams.hasOwnProperty(prop) && jQuery.inArray(prop, ajaxParams) == -1) {
						dataobj[prop] = inParams[prop];
					}
				}

				return $.ajax({
					type: "GET",
					url: (inParams.url ? inParams.url : "/lib/libAjaxFuncs.asp"),
					data: dataobj,
					dataType: (inParams.dataType ? inParams.dataType: "json"),
					async: (inParams.async ? inParams.async : true),
					contentType: "application/x-www-form-urlencoded; charset=utf-8",
					error: function (xhr, text_status, thrownError) {
						if (text_status != "abort") {

							if(xhr.responseText && xhr.responseText.indexOf("NO VALID USER") !== -1){
								window.location.href = "../Main/NoConnection.asp";
								return false;
							}
							else{

								if(xhr.status == 500){
									if(Common.isDevelopment()){
										alert("Error: " + xhr.responseText + ", Status: " + xhr.status + ", " + text_status);
									}
									else{
										alert("Internal server error");
									}
								}
								else{
									//alert("Error: " + xhr.responseText + ", Status: " + xhr.status + ", " + text_status);
								}

								return false;
							}
						}
						else{
							return false;
						}
					},
					success: function(data) {
					}
				});
			},
			post: function(func, appendCommonParams, inParams){

				var self = this;

				if(inParams.url && inParams.url.length > 0){
					//Jos annettu poikkeava url, ei tarvitse vaatia Func - parametria.
				}
				else{
					if(func === undefined){
						return;
					}

					if(func.length === 0){
						return;
					}
				}

				var dataobj = {
					FUNC: func,
					Dummy: new Date()
				};

				//Kopioidaan parametrit
				for (var prop in inParams) {
					if (inParams.hasOwnProperty(prop)) {
						dataobj[prop] = inParams[prop];
					}
				}

				//Lisätään common luokan parametrit pyyntöön
				if(appendCommonParams){
					var cParams = Common.getParams();

					for (var prop in cParams) {

						var propName = prop;

						if (cParams.hasOwnProperty(propName) && !dataobj.hasOwnProperty(propName)) {

							if(propName === "CSRF"){
								propName = "ctoken";
								dataobj[propName] = cParams["CSRF"];
							}
							else{
								dataobj[propName] = cParams[propName];
							}
						}
					}
				}

				return $.ajax({
					type: "POST",
					url: (inParams.url ? inParams.url : "/lib/libAjaxFuncs.asp"),
					dataType: (inParams.dataType ? inParams.dataType: "json"),
					data: dataobj,
					contentType: "application/x-www-form-urlencoded; charset=utf-8",
					error: function (xhr, text_status, thrownError) {

						if(self.userAborted(xhr)){
							console.log("User aborted ajax request!");
						}
						else{
							if(xhr.status == 500){

								if(Common.isDevelopment()){
									alert("Error: " + xhr.responseText + ", Status: " + xhr.status + ", " + text_status);
								}
								else{
									alert("Internal server error");
								}
							}
							else{
								alert("Error: " + xhr.responseText + ", Status: " + xhr.status + ", " + text_status);
							}
						}
						return false;
					},
					success: function(data) {
					}
				});
			},

			//Palauttaa true jos ajax pyyntö on keskeytetty käyttäjän toimesta, esim esc tai enter lyönnistä.
			userAborted: function(xhr){
				return !xhr.getAllResponseHeaders();
			}
		}
	})();

	CommonAjax = (function(){ //Alias ajax luokalle .NET:iin
		return Ajax;
	})();

	//TR, MVR ja Tyotapaturma mittareihin liittyvät funktiot
	Mittari = (function(){

		return {
			hae_mittauksen_huomautukset: function(mittari_prefix, tid) {

				if (mittari_prefix == "TTT") {
					var d = new $.Deferred;
					return d.resolve(true);
				}

				return Ajax.fetch("HAE_MITTAUKSEN_HUOMAUTUKSET", { mittari: mittari_prefix, tid: tid });

			},

			hae_mittaus_paivamaarat: function(mittari, pid) {
				return Ajax.fetch("Hae_Mittaus_Paivamaarat", { mittari: mittari, pid: pid });
			},

			tarkista_kameran_kaytto: function()  {
				return Ajax.fetch("TARKISTA_KAMERAN_KAYTTO", {});
			},

			hyvaksy_kameran_kaytto: function() {
				return Ajax.post("HYVAKSY_KAMERAN_KAYTTO", true, {});
			},

			doBindingsForDynamicRows: function (){

				var self = this;

				$("img[id^='upfile']").unbind("click");
				$("img[id^='upfile']").click(function(){
					var id = $(this).prop("id").split("upfile")[1];

					$("#UploadFileName" + id).trigger("click");
				});

				$("img[id^='upfileCam']").unbind("click");
				$("img[id^='upfileCam']").click(function(e){

					var el = $(this);
					var consent_date = $(this).data("consent") || "";

					if (consent_date.toString().length > 0) {
						var id = el.prop("id").split("upfileCam")[1];
						$("#UploadFileNameCam" + id).trigger("click");
					}
					else {

						//Hyväksytetään kameran käyttö
						var ds = "<p>" + Common.getText(2474) + "<br /><br/>" + Common.getText(2475) + "<br /><br />" + Common.getText(2477) + "</p>"
						var params = {
							title : Common.getText(2476),
							height: 300,
							width: 400,
							content: ds,
							buttons: [
								{
									text: Common.getText(113), //Kyllä
									id: 'dlg-btn-yes',
									click: function(){
										var dlg = $(this);
										self.hyvaksy_kameran_kaytto().done(function(resp2){
											if (parseInt(resp2) === 1)
											{
												dlg.dialog('close');

												$(el).data("consent", new Date());
											}
											else {
												dlg.dialog('close');
											}
										});
									}
								},
								{
									text: Common.getText(112), //Ei
									id: 'dlg-btn-no',
									click: function(){
										$(this).dialog('close');
									}
								}
							]
						};

						Common.getDialog("#dialog", params);

						e.preventDefault();
						return false;
					}
				});

				$("input[id^='UploadFileName']").unbind("change");
				$("input[id^='UploadFileName']").change(function(){
					var id = $(this).prop("id").split("UploadFileName")[1];
					var val = $(this).val();
					val = val.substring(val.lastIndexOf('\\') + 1,val.length)
					$('#fname' + id).val(val);
					$('#fchanged' + id).val(1);

					$('#lastUploadMethod' + id).val("file");
				});

				$("input[id^='UploadFileNameCam']").unbind("change");
				$("input[id^='UploadFileNameCam']").change(function(){
					var id = $(this).prop("id").split("UploadFileNameCam")[1];
					var val = $(this).val();
					val = val.substring(val.lastIndexOf('\\') + 1,val.length)
					$('#fname' + id).val(val);
					$('#fchanged' + id).val(1);

					$('#lastUploadMethod' + id).val("cam");
				});
			},

			luo_huomautus_rivit: function(start, amount, camera_consent){
				var htmlTotal = "";
				for(i = start; i < (start+amount); i++){
					htmlTotal += Mittari.luo_huomautus_rivi(i, undefined, camera_consent);
				}

				return htmlTotal;
			},

			luo_huomautus_rivi: function (num, huomautus, camera_consent){
				var html = "";

				if (huomautus === undefined) {
					huomautus = {
						"huom": "",
						"vast": "",
						"dline": "",
						"fixed": "",
						"hid": 0,
						"liite": ""
					};
				}

				html += "<tr id='row" + num + "'>";
				html += "<td style='vertical-align: top;' class='paddington'><input type='text' value='" + huomautus.huom + "' name='huom" + num + "' size='24'></td>";
				html += "<td style='vertical-align: top;' class='paddington'><input type='text' value='" + huomautus.vast + "' name='vast" + num + "' size='24'></td>";
				html += "<td style='vertical-align: top;' class='paddington'><input type='text' class='picker' value='" + huomautus.dline + "' name='dline" + num + "' size='10'></td>";
				html += "<td style='vertical-align: top;' class='paddington'><input type='text' class='picker' value='" + huomautus.fixed + "' name='fixed" + num + "' size='10'></td>";
				html += "<td class='paddington'>";
				html += "<img src='../images/liite.gif' id='upfile" + num + "' style='cursor: pointer;' />&nbsp;";
				html += "<img src='../images/camera_add.png' id='upfileCam" + num + "' data-consent='" + camera_consent + "' style='cursor: pointer;' />";
				html += "<input name='UploadFileName" + num + "' id='UploadFileName" + num + "' onKeyPress='return false;' style='display: none;' type='File' value='' />";
				html += "<input name='UploadFileNameCam" + num + "' id='UploadFileNameCam" + num + "' accept='image/*' id='capture' capture='camera' onKeyPress='return false;' style='display: none;' type='file' value=''/>";
				html += "<input type='text' id='fname" + num + "' style='width: 80px; border-width: 0; color blue; font-size: 8px;' value='" + huomautus.liite + "' />";
				html += "<input type='hidden' name='lastUploadMethod" + num + "' id='lastUploadMethod" + num + "' value='' />";
				html += "<input type='hidden' name='hid" + num + "' id='hid" + num + "' value='" + huomautus.hid + "' />";
				html += "<input type='hidden' name='fchanged" + num + "' id='fchanged" + num + "' value='0' />";
				html += "</td>";

				html += "</tr>";

				return html;
			}
		}

	})();

	//Projektiin liittyvät js funktiot
	Projekti = (function(){

		return {

			hae_kayttajan_organisaatiot: function(uid){

				return Ajax.fetch("HAE_KAYTTAJAN_ORGANISAATIOT", { UID: uid });

			},


			onko_kopiolaitosta: function(pid){

				return Ajax.fetch("ONKO_KOPIOLAITOSTA", { PID: pid });

			},

			//Tarjoussalkku haussa käytettävä versio.
			onko_kopiolaitosta_ts: function(pid){

				return Ajax.fetch("ONKO_KOPIOLAITOSTA_TS", { PID: pid, url: "/Tarjoussalkku/lib/libAjaxFuncs.asp" });

			},

			hae_kayttajan_projektin_muutosloki: function(params){

				return Ajax.fetch("HAE_KAYTTAJAN_PROJEKTIN_MUUTOSLOKI", params);

			},

			hae_kayttajan_projektin_kirjautumiset: function(params){

				return Ajax.fetch("HAE_KAYTTAJAN_PROJEKTIN_KIRJAUTUMISET", params);

			}

		}

	})();

	Asiakirja = (function(){

		return {

			hae_referenssitiedostot_dialog: function(inParams, asiakirjat) {

				var texts = "2186, 2187, 2188, 54, 1092, 302, 2176, 2189, 23, 20, 303, 304, 2190, 1461";

				Common.init_texts(inParams.Kieli, texts).done(function(r){

					var ds = "";

					ds += Common.getText(2186);
					ds += "<br />";
					ds += Common.getText(2187);

					ds += "<br /><br />";

					ds += "<table id='ref_table'>";
					ds += "<thead>";
					ds += "<tr>";
					ds += "<td>";
					ds += Common.getText(302); //Valinta
					ds += "</td>";

					ds += "<td>";
					ds += Common.getText(2176); //Pääasiakirja
					ds += "</td>";

					ds += "<td>";
					ds += Common.getText(2189); //Referenssiasiakirja
					ds += "</td>";

					ds += "<td>";
					ds += Common.getText(23); //Versio
					ds += "</td>";

					ds += "<td>";
					ds += Common.getText(20); //Pvm
					ds += "</td>";

					ds += "</tr>";
					ds += "</thead>";

					ds += "<tbody>";

					for(var a = 0; a < asiakirjat.length; a++){

						var refrid = parseFloat(asiakirjat[a].refrid);
						var maxrid = parseFloat(asiakirjat[a].maxrefrid);
						var refaid = asiakirjat[a].refaid;
						var mainaid = asiakirjat[a].mainaid;
						var maxaid = parseInt(asiakirjat[a].maxaid);
						var is_old_rev = false;

						if(parseFloat(maxrid) > parseFloat(refrid)){
							is_old_rev = true;
						}

						ds += "<tr>";

						ds += "<td>";
						ds += "<input type='radio' name='rdo_selection_" + refaid + "_" + mainaid + "' data-mainaid='" + mainaid + "' data-maxaid='0' value='0' CHECKED />&nbsp;" + Common.getText(303); //Valittu
						ds += "</td>";

						ds += "<td>";
						ds += asiakirjat[a].mainselite;
						ds += "</td>";

						ds += "<td>";
						ds += asiakirjat[a].refselite;
						ds += "</td>";

						ds += "<td>";
						ds += asiakirjat[a].refrid2;
						ds += "</td>";

						ds += "<td>";
						ds += asiakirjat[a].reftuontipvm;
						ds += "</td>";

						ds += "</tr>";

						if(is_old_rev){
							ds += "<tr>";

							ds += "<td>";
							ds += "<input type='radio' name='rdo_selection_" + refaid + "_" + mainaid + "' data-mainaid='" + mainaid + "' data-maxaid='" + maxaid + "' value='1' />&nbsp;" + Common.getText(304); //Uusin versio
							ds += "</td>";

							ds += "<td>";
							ds += asiakirjat[a].mainselite;
							ds += "</td>";

							ds += "<td>";
							ds += asiakirjat[a].refselite;
							ds += "</td>";

							ds += "<td>";
							ds += asiakirjat[a].maxrefrid2;
							ds += "</td>";

							ds += "<td>";
							ds += asiakirjat[a].maxreftuontipvm;
							ds += "</td>";

							ds += "</tr>";
						}

						ds += "<tr>";
						ds += "<td colspan='5'>";
						ds += "<input type='radio' name='rdo_selection_" + refaid + "_" + mainaid + "' data-mainaid='" + mainaid + "' data-maxaid='0' value='2' />&nbsp;" + Common.getText(2190); //Poista linkitys
						ds += "<hr>";
						ds += "</td>";
					}

					ds += "</tbody>";

					ds += "</table>";

					//Uusi ryhmä
					var params = {
						title : Common.getText(2188),
						height: 'auto',
						width: 700,
						content: ds,
						buttons: [
							{
								text: Common.getText(1461),
								click: function(){
									//Kerätään rdo arvot kasaan ja jatketaan
									var lstr = "";

									$("input[type='radio'][name^='rdo_selection_']:checked").each(function(){
										var mainaid = $(this).data("mainaid");

										var idpart = $(this).prop("name").split("rdo_selection_")[1];
										var refaid = idpart.split("_")[0];

										var maxaid = $(this).data("maxaid");
										var val = $(this).val();

										lstr += mainaid + "$$" + refaid + "$$" + maxaid + "$$" + val + ">>";
									});

									if(inParams.dropped && parseInt(inParams.dropped) === 1){
										$("#fileupload").find("#LinkSelection").val(lstr);
										$("#fileupload").find(".singleGroupDisabled").prop("disabled", false);
										$("#fileupload").prop("action", "LisaaAsiakirjat.asp?ParentID=" + inParams.parentid + "&dropped=1");
										$("#fileupload").find("#disableds").val(inParams.disableds);
										$("#fileupload").prop("enctype", "application/x-www-form-urlencoded");
										$("#fileupload").submit();
									}
									else if(inParams.zipupload && parseInt(inParams.zipupload) === 1){
										$("#form_puretut").find("#LinkSelection").val(lstr);
										document.getElementById("form_puretut").action = "AddUnzippedDocuments.aspx";
										WebForm_OnSubmit = function() { return true; };

										javascript:__doPostBack('btn_continue','');
									}
									else{
										$("#paivita").find("#LinkSelection").val(lstr);
										var left = (screen.width/2)-(1024/2);
										var top = (screen.height/2)-(600/2) - 100;
										window.open("","PaivitaAsiakirjat","width=1075,height=800,toolbar=0,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,maximize=yes,copyhistory=no, top="+top+", left="+left);
										var a = window.setTimeout("document.paivita.submit();",100);
									}
									$(this).dialog('close');
								}
							},
							{
								text: Common.getText(1092),
								click: function() {
									$(this).dialog('close');
								}
							}
						]
					};

					Common.getDialog("#dialog", params);

				});

			}

		}

	})();

	Tyomaa = (function(){

		return {

			props:  {
				container:  "",
				Kieli:  "",
				pid:  0,
				sivu:  0,
				vahvuus_max: 20
			},

			poista_vahvuus_otsikko: function(id){

				if(confirm(Common.getText(2171))){

					Ajax.post("POISTA_VAHVUUS_OTSIKKO", true, {
						ID: id
					}).done(function(response){

						Tyomaa.hae_tyomaan_vahvuus(Tyomaa.props.pid, Tyomaa.props.Kieli, Tyomaa.props.sivu, Tyomaa.props.container, 1);

					});
				}

			},

			vahvuus_lisays: function(){

				if($("#vahvuus_container").find(".vahvuus").length >= Tyomaa.props.vahvuus_max){
					alert(Common.getText(2169).replace("{0}", Tyomaa.props.vahvuus_max));
					return false;
				}

				var ds = "<div class='content'>";
				ds += "<span class='otsikko'>" + Common.getText(310) + "</span>";
				ds += "&nbsp;<input type='text' autocomplete='off' name='Nimi_uusi' id='Nimi_uusi' style='WIDTH: 300px' value='' />";
				ds += "</div>";

				ds += "<br />";

				//Uusi ryhmä
				var params = {
					title : Common.getText(310),
					height: 200,
					width: 420,
					content: ds,
					buttons: [
						{
							text: Common.getText(54),
							click: function(){
								var dlg = $(this);

								var nimi = $.trim($("#Nimi_uusi").val());

								if(nimi.length === 0){
									alert(Common.getText(2170));
									return false;
								}

								var test = nimi.match(/[\:\\\/\*\?\"\<\>\|\#\'\&]+/g,'');

								if(test != null){

									if(test.length > 0){

										alert(Common.getText(1927) + " : \ / * ? < > | & # ' \u0022");

										return false;
									}
								}

								//Tarkasta ryhmän nimen kelvollisuus
								if(nimi.substring(nimi.length-1) == '.'){
									alert(Common.getText(1440));
									return false;
								}

								if(nimi.length > 50){
									alert(Common.getText(1900));
									return false;
								}

								Ajax.post("TALLENNA_UUSI_VAHVUUS", true, {
									Selite: nimi
								}).done(function(response){

									if(parseInt(response) === 1){
										Tyomaa.hae_tyomaan_vahvuus(Tyomaa.props.pid, Tyomaa.props.Kieli, Tyomaa.props.sivu, Tyomaa.props.container, 1);
									}

									Common.closeDialog();

								});
							}
						},
						{
							text: Common.getText(1092),
							click: function() {
								$(this).dialog('close');
							}
						}
					]
				};

				Common.getDialog("#dialog", params);

			},

			vahvuus_otsikko_muokkaus: function(id, value, jarjestys){

				var ds = "<div class='content'>";
				ds += "<span class='otsikko'>" + Common.getText(1499) + "</span>";
				ds += "&nbsp;<input type='text' autocomplete='off' name='Nimi_uusi' id='Nimi_uusi' style='WIDTH: 250px' value='" + value + "' />";
				ds += "</div>";

				ds += "<br />";

				ds += '<img src="../images/error.png" style="border: none;">&nbsp;';
				ds += '<span style="color: orange;">';
				ds += Common.getText(2168);
				ds += '</span>';

				//Uusi ryhmä
				var params = {
					title : Common.getText(1499),
					height: 200,
					width: 420,
					content: ds,
					buttons: [
						{
							text: Common.getText(54),
							click: function(){
								var dlg = $(this);

								var nimi = $.trim($("#Nimi_uusi").val());

								if(nimi.length === 0){
									alert(Common.getText(2170));
									return false;
								}

								var test = nimi.match(/[\:\\\/\*\?\"\<\>\|\#\'\&]+/g,'');

								if(test != null){

									if(test.length > 0){

										alert(Common.getText(1927) + " : \ / * ? < > | & # ' \u0022");

										return false;
									}
								}

								//Tarkasta ryhmän nimen kelvollisuus
								if(nimi.substring(nimi.length-1) == '.'){
									alert(Common.getText(1440));
									return false;
								}

								if(nimi.length > 50){
									alert(Common.getText(1900));
									return false;
								}

								Ajax.post("TALLENNA_VAHVUUS", true, {
									ID: id,
									Selite: nimi,
									Jarjestys: jarjestys
								}).done(function(response){

									if(parseInt(response) === 1){
										Tyomaa.hae_tyomaan_vahvuus(Tyomaa.props.pid, Tyomaa.props.Kieli, Tyomaa.props.sivu, Tyomaa.props.container, 1);
									}

									Common.closeDialog();

								});
							}
						},
						{
							text: Common.getText(1092),
							click: function() {
								$(this).dialog('close');
							}
						}
					]
				};

				Common.getDialog("#dialog", params);
			},

			hae_tyomaan_vahvuus: function(pid, kieli, sivuid, append_to, vastaava, as_table){

				var enabled = !($(append_to).hasClass("non_editable"));

				Ajax.fetch("HAE_PROJEKTIN_TYOMAAN_VAHVUUS", {
					"PID": pid,
					"Kieli": kieli,
					"Sivu": sivuid
				}).done(function(resp){

					var str = "";
					var inputName = "";

					if(as_table && parseInt(as_table) === 1){
						str = '<table valign="top" border="0" width="100%" cellspacing="2" cellpadding="0">';
					}
					else{
						$(append_to).html("");
					}

					for(var x = 0; x < resp.length; x++){

						jarj = (x + 1);
						selite = $.trim(resp[x].selite);
						can_delete = parseInt(resp[x].can_delete);
						poistettu = parseInt(resp[x].poistettu);
						value = "";

						if(resp[x].jarjestys !== undefined){
							jarj = parseInt(resp[x].jarjestys);
						}

						julkaisuID = parseInt(resp[x].julkaisuid);

						if(julkaisuID === -1 || julkaisuID === 0){
							switch(jarj){
								case 1:
									inputName = "ValvojatKPL";

									if(parseInt(sivuid) > 0){
										value = resp[x].valvojatkpl;
									}

									break;
								case 2:
									inputName = "OsaUrakTyonJohtKPL";

									if(parseInt(sivuid) > 0){
										value = resp[x].osauraktyonjohtkpl;
									}

									break;
								case 3:
									inputName = "OsaUrakKPL";

									if(parseInt(sivuid) > 0){
										value = resp[x].osaurakkpl;
									}

									break;
								case 4:
									inputName = "SivuUrakKPL";

									if(parseInt(sivuid) > 0){
										value = resp[x].sivuurakkpl;
									}

									break;
								default:
									inputName = "MuutKPL";

									if(parseInt(sivuid) > 0){
										value = resp[x].muutkpl;

										if(value.indexOf(",") !== -1){
											var vArr = value.split(",");

											valIndex = (jarj - 5);

											if(vArr[valIndex] !== undefined){
												value = $.trim(vArr[valIndex]);
											}
											else{
												value = "";
											}

										}
										else{
											if(jarj > 5){
												value = "";
											}
										}
									}

									break;
							}
						}
						else{
							inputName = 'MuutKPL';
						}

						if(as_table && parseInt(as_table) === 1){
							if(poistettu === 0){
								str += "<tr>";
								str += '<td valign="top" width="11%" align="right">' + value + '</td>';
								str += '<td valign="top" width="89%"> ' + selite + '</td>';
								str += "</tr>";
							}
						}
						else{
							if(poistettu === 1){
								str += "<input style='width: 40px;' " + (!enabled ? "DISABLED" : "") + " class='vahvuus' type='hidden' data-id='" + resp[x].id + "' name='" + inputName+ "' id='" + inputName + "' value='" + value + "' />";
							}
							else{
								str += "&nbsp;";
								str += "<input style='width: 40px;' " + (!enabled ? "DISABLED" : "") + " class='vahvuus' type='text' data-id='" + resp[x].id + "' name='" + inputName+ "' id='" + inputName + "' value='" + value + "' />&nbsp;" + selite;

								if(parseInt(vastaava) === 1 && enabled){
									str += "&nbsp;"
									str += '<img src="../images/edit.gif" title="' + Common.getText(60) + '" onclick="Tyomaa.vahvuus_otsikko_muokkaus(' + resp[x].id + ', \'' + selite + '\', ' + jarj + ');" />';

									if(can_delete === 1 && enabled){
										str += "&nbsp;";
										str += '<img src="../images/delete.gif" title="' + Common.getText(62) + '" onclick="Tyomaa.poista_vahvuus_otsikko(' + resp[x].id + ');" />';
										if(poistettu === 1){
														str += "&nbsp;(poistettu)";
													}
									}
									else{
										if(inputName === "MuutKPL"){
											var m = resp[x].maxmuut.split(",");
											var j = 4;

											for(var i = 0; i < m.length; i++){
												if($.trim(m[i]).length === 0 && (jarj === (5 + i)) && enabled){
													str += "&nbsp;";
													str += '<img src="../images/delete.gif" title="' + Common.getText(62) + '" onclick="Tyomaa.poista_vahvuus_otsikko(' + resp[x].id + ');" />';
													if(poistettu === 1){
														str += "&nbsp;(poistettu)";
													}
												}

												j++;
											}
										}
									}
								}

								str += "<br />";
							}
						}

						Tyomaa.props.container = append_to;
						Tyomaa.props.Kieli = kieli;
						Tyomaa.props.pid = pid;
						Tyomaa.props.sivu = sivuid;
					}

					if(as_table && parseInt(as_table) === 1){
						str += "</table>";
					}
					else{
						if(parseInt(vastaava) === 1 && enabled){
							str += "<br />";
							str += "<img style='padding: 0px 10px 5px 0px;' src='../images/add.png' title='" + Common.getText(310) + "' onclick='Tyomaa.vahvuus_lisays();' />";
						}
					}

					$(append_to).html(str);

				});

			},

			tarkasta_tyomaa_sivu: function(pid, uid, sivu){

				return Ajax.fetch("TARKASTA_TYOMAA_SIVU", {
					"PID": pid,
					"UID": uid,
					"Sivu": sivu
				});

			},

			tarkasta_temp_sivu: function(pid, uid, sivu, checkdate){

				return Ajax.fetch("TARKASTA_TEMP_SIVU", {
					"PID": pid,
					"UID": uid,
					"Sivu": sivu,
					"CheckDate": checkdate
				});

			},

			tallenna_temp_sivu: function(pid, uid, sivu, tyomaapvm){

				return Ajax.post("TALLENNA_TEMP_SIVU", true, {
					"PID": pid,
					"UID": uid,
					"Sivu": sivu,
					"Tyomaapvm": tyomaapvm
				});

			},

			poista_temp_sivu: function(pid, uid, tyomaapvm){

				return Ajax.post("POISTA_TEMP_SIVU", true, {
					"PID": pid,
					"UID": uid,
					"Tyomaapvm": tyomaapvm
				});

			},

			paivita_temp_sivu: function(pid, uid, sivu){

				return Ajax.post("PAIVITA_TEMP_SIVU", true, {
					"PID": pid,
					"UID": uid,
					"Sivu": sivu
				});

			}
		}

	})();

	HtmlHelpers = (function(){

		var DropDown = function(id, data, params){

			params.disabled = (params.disabled === undefined ? false: params.disabled);

			if(id.indexOf("#") === -1){
				id = "#" + id;
			}

			if($(id).length === 0){
				console.info("Dropdown DOM node with id: '" + id + "' not found!");
				return false;
			}

			if(params.empty){
				$(id).find("option").remove();
			}

			if(params.emptyExceptFirst){
				$(id).find("option:gt(0)").remove();
			}

			if(params.disabled){
				$(id).prop("disabled", true);
			}
			else{
				$(id).prop("disabled", false);
			}

			if(data.length === 0){
				console.info("NO JSON Data for dropdown");
			}

			if(params.optionValue.length === 0){
				console.info("No dropdown option value specified");
				return false;
			}

			if(params.optionText.length === 0){
				console.info("No dropdown option text specified");
				return false;
			}

			if(params.extraClasses && params.extraClasses.length > 0){
				$(id).addClass(params.extraClasses);
			}

			if(params.newItem && params.newItem.value){
				$(id).append("<option value='" + params.newItem.value + "'>" + params.newItem.text + "</option>");
			}

			if(data.length > 0){
				for(var r = 0; r < data.length; r++){

					var extraClasses = "";
					//Halutaanko option:eille lisäluokkia, tarkistetaan ehto jolla laitetaan ja attribuutin nimi
					if(params.extra_option_classes && $.isArray(params.extra_option_classes)){
						for(var c = 0; c < params.extra_option_classes.length; c++){
							var o = params.extra_option_classes[c];

							if($.isPlainObject(o)){
								var testAttr = o.attribute;
								var testCond = o.condition;
								var className = o.key;

								var result = false;

								if(data[r][testAttr].toString().length > 0){
									result = eval(data[r][testAttr] + testCond);
								}

								if(result){
									extraClasses += className;
								}
							}
						}
					}

					if(params.selectedValue && params.selectedValue == data[r][params.optionValue]){
						$(id).append("<option class='" + extraClasses + "' value='" + data[r][params.optionValue] + "' SELECTED>" + data[r][params.optionText] + "</option>");
					}
					else{
						if(data[r] === ""){
						}
						else{
							$(id).append("<option class='" + extraClasses + "' value='" + data[r][params.optionValue] + "'>" + data[r][params.optionText] + "</option>");
						}
					}
				}
			}
			else{
				//Assoc array?
				for(var r in data){

					var extraClasses = "";

					if(params.extra_option_classes && $.isArray(params.extra_option_classes)){
						for(var c = 0; c < params.extra_option_classes.length; c++){
							var o = params.extra_option_classes[c];

							if($.isPlainObject(o)){
								var testAttr = o.attribute;
								var testCond = o.condition;
								var className = o.key;

								var result = false;

								if(data[r][testAttr].toString().length > 0){
									result = eval(data[r][testAttr] + testCond);
								}

								if(result){
									extraClasses += className;
								}
							}
						}
					}

					if(params.selectedValue && params.selectedValue == data[r][params.optionValue]){
						$(id).append("<option class='" + extraClasses + "' value='" + data[r][params.optionValue] + "' SELECTED>" + data[r][params.optionText] + "</option>");
					}
					else{
						if(data[r] === ""){
						}
						else{
							$(id).append("<option class='" + extraClasses + "' value='" + data[r][params.optionValue] + "'>" + data[r][params.optionText] + "</option>");
						}
					}
				}
			}

			if(!params.selectedValue && params.setDefaultOnEmpty){
				//Asetetaan ensimmäinen data arvo valituksi
				try{
					params.selectedValue = data[0][params.optionValue];
				}
				catch(err){
					console.log("Error setting default value: " + err.message);
				}
			}

			if(params.selectedValue && params.childElement){
				//Täydennetään lapsi alasvetolista
				if($(params.childElement).length > 0){
					if(data.length > 0){
						for(var r = 0; r < data.length; r++){
							if(params.selectedValue && params.selectedValue == data[r][params.optionValue]){

								children = data[r].children;

								if(children && !params.disabled){
									this.DropDown(params.childElement, children, {
										optionValue : params.optionValue,
										optionText : params.optionText,
										selectedValue: (params.childElementSelectedValue ? params.childElementSelectedValue : 0),
										empty : params.empty,
										emptyExceptFirst: params.emptyExceptFirst,
										disabled: false
									});
								}
							}
						}
					}
				}
			}

			return $(id);
		};

		return {
			DropDown: DropDown
		}

	})();

	Tarjous = (function(){

		var render_tarjoukset = function(json, inTexts, opts)
		{
			$("#tarjoukset").empty();

			var str = "";
			var tarjoukset = json.tarjoukset;
			var koko_yhteensa = 0;
			var tiedostot_yhteensa = 0;

			if(tarjoukset.length > 0){
				str += "<u><b>" + inTexts.jatetyttarjoukset + "</u></b><br /><br />";
			}

			for(var t = 0; t < tarjoukset.length; t++){

				var cls = 'tarjous_header';

				if(tarjoukset[t].TiedostotOk == 0){
					cls = 'tarjous_header_red';
				}

				var warning_msg = "";

				if(tarjoukset[t].TiedostotOk == 0 || tarjoukset[t].TiedostotOk == -1){
					warning_msg = " (" + inTexts.tallennus_epaonnistui + ")";
				}

				if(tarjoukset[t].Pvm == tarjoukset[t].MinPvm){
					str += "<span class='" + cls + "'>" + inTexts.tarjous + ", " + tarjoukset[t].Pvm;

					if(parseInt(tarjoukset[t].ParentID) > 0){
						str += " (" + inTexts.lisakirje + ") ";
					}

					str += warning_msg;

					str += "</span><br />";
				}
				else{
					str += "<span class='" + cls + "'>" + inTexts.tarjouksen_taydennys + ", " + tarjoukset[t].Pvm;

					if(parseInt(tarjoukset[t].ParentID) > 0){
						str += " (" + inTexts.lisakirje + ") ";
					}

					str += warning_msg;

					str += "</span><br />";
				}

				if(tarjoukset[t].files.length > 0){

					str += "<br />";

					if(opts && opts.from_uutiset == 1){
						str += "<table class='file_table'>";
					}
					else{
						str += "<table class='file_table noutonakyma'>";
					}

					str += "<thead>";
					str += "<tr>";
					str += "<td class='tarjous_table_header'>" + inTexts.tiedostonnimi + "</td>";
					str += "<td class='tarjous_table_header'>" + inTexts.selite + "</td>";

					if(opts && opts.from_uutiset == 1){
						str += "<td class='tarjous_table_header'>" + inTexts.koko + " (" + inTexts.kilotavua + ")" + "</td>";
					}

					str += "</tr>";
					str += "</thead>";

					for(var f = 0; f < tarjoukset[t].files.length; f++){

						var file = tarjoukset[t].files[f];

						str += "<tr>";
						str += "<td class='word-break tarjous_table_cell'>" + file.TiedostonNimi + "</td>";
						str += "<td class='word-break tarjous_table_cell'>" + file.Selite + "</td>";

						if(opts && opts.from_uutiset == 1){
							str += "<td>" + file.KokoKB + "</td>";
						}

						str += "</tr>";

						koko_yhteensa += file.KokoKB;
						tiedostot_yhteensa++;
					}

					str += "</table>";

					str += "<br />";
				}

				if((tarjoukset[t].Tarjoaja && tarjoukset[t].Tarjoaja.length > 0) || (tarjoukset[t].TarjoajaYritys && tarjoukset[t].TarjoajaYritys.length > 0) || (tarjoukset[t].Kommentti && tarjoukset[t].Kommentti.length > 0)){
					str += "<div class='kommentti_div'>";
					str += "<table>";

					str += "<tr>";
					str += "<td>" + inTexts.nimi + ":</td>";
					str += "<td>" + tarjoukset[t].Tarjoaja + "</td>";
					str += "</tr>";

					str += "<tr>";
					str += "<td>" + inTexts.yritys + ":</td>";
					str += "<td>" + tarjoukset[t].TarjoajaYritys + "</td>";
					str += "</tr>";

					str += "<tr>";
					str += "<td>" + inTexts.kommentti + ":</td>";
					str += "<td>" + tarjoukset[t].Kommentti + "</td>";
					str += "</tr>";

					str += "</table>";
					str += "</div>";
				}
			}

			$("#tarjoukset").html(str);

			return {
				"koko_yhteensa": koko_yhteensa,
				"kpl_yhteensa": tiedostot_yhteensa
			};
		}

		return {
			render_tarjoukset: render_tarjoukset
		}

	})();

	Organisaatio = (function () {

		var hae_laskutustiedot = function(julkaisuid, on_missing) {

			return Ajax.fetch("HAE_ORGANISAATION_LASKUTUSTIEDOT", {
				"JulkaisuID": julkaisuid
			}).done(function(resp){
				if (resp == "-2") {
					if (typeof on_missing === "function") {
						on_missing();
					}
				}
			});
		}

		return {
			hae_laskutustiedot: hae_laskutustiedot
		}

	})();

	Utils = (function() {

		// as long as it continues to be invoked, raise on every interval
		var throttle = function (func, interval) {
		  var timeout;
		  return function() {
		    var context = this, args = arguments;
		    var later = function () {
		      timeout = false;
		    };
		    if (!timeout) {
		      func.apply(context, args)
		      timeout = true;
		      setTimeout(later, interval)
		    }
		  }
		}

		return {
			throttle: throttle
		}

	})();

	//Yleiset js funktiot
	Common = (function (){

	  var texts = {};
	  var text_init_done = false;

	  var pParams = {
		UID: 0,
		PID: 0,
		Selite: "",
		CSRF: "",
		Kieli: "_fi"
	  };

	  var textsToFetch = "2099,1092,120,218,2100,608,670,1992,2101,2102,462,2103,2104,179,401,2105,2106,2107";
	  textsToFetch += ",2108,2109,2110,2111,2112,319,320,838,48,1927,1440,389,325,1453,2125";
	  textsToFetch += ",1443,42,21,23,20,2132,70,2134,1577,2148,2153,2142,2143,2144,2145,2146,2147,2148,60,2172,2185";
	  textsToFetch += ",1443,41,42,21,22,23,20,2132,70,2134,1577,2148,2153,2154,2142,2143,2144,2145,2146,2147,60,2172";
	  textsToFetch += ",112,113,2177,2178,2179,2183,2184";
	  textsToFetch += ",62,1499,54,1900,1927,2168,310,2169,2170,2171,195,844,638"
	  textsToFetch += ",832,1052,834,123,1888,1889,1575,835,31,32,591,24,25,450,1570,78,2117,2118,1569,1151,833"
	  textsToFetch += ",1071,1072,1780,1070,1069,1475,1258,1781,2119,2120,2121";
	  textsToFetch += ",397,1104,1573,1422,485,2223,2329,2334,2335,2342,2474,2475,2476,2477";

	  var getKieli = function(){
		return pParams.Kieli;
	  };

	  var getCSRF = function(){
		return pParams.CSRF;
	  };

	  var getParams = function(){
		return pParams;
	  };

	  var getText = function(id){

		if(jQuery.isEmptyObject(texts)){


			this.init_texts('').done(function(){

				if(texts[id] === undefined){
					console.warn("Localized text with id " + id + " not found!");
					return false;
				}

				return texts[id].text;

			});

		}
		else{
			if(texts[id] === undefined){
				console.warn("Localized text with id " + id + " not found!");
				return false;
			}

			return texts[id].text;
		}
	  };

	  var closeDialog = function(target_element)
	  {
			if(target_element){
				if($(target_element).closest('.ui-dialog').is(':visible')) {
					$(target_element).dialog("close");
				}
			}
			else{
				if($("#dialog").closest('.ui-dialog').is(':visible')) {
					$("div#dialog").dialog("close");
				}
			}
	  };

	  var isInteger = function(s){
		var i;
		for (i = 0; i < s.length; i++){
			// Check that current character is number.
			var c = s.charAt(i);
			if (((c < "0") || (c > "9"))) return false;
		}
		// All characters are numbers.
		return true;
	  }

	  //Mapataan muutoslokin _fi tapahtuma istunnon kielen mukaiseksi
	  var mapChangeLogEvent = function(inEvent){

		switch(inEvent.toLowerCase()){
			case "muokkaus":
				return getText(1071);
			case "palautus":
				return getText(1780);
			case "poisto":
				return getText(1070);
			case "p\u00E4\ivitys":
				return getText(1069);
			case "ryhm\u00E4n nimen muutos":
				return getText(1475);
			case "siirto":
				return getText(1258);
			case "tuonti":
				return getText(1781);
			case "uusi":
				return getText(1072);
			default:
				return inEvent;
		}
	  };

	  var checkEmail = function(emailStr){
		var error_txt_enter_email = getText(2114);
		var error_txt_invalid_form = getText(680);
		var error_txt_username_invalid = getText(682);
		var error_txt_invalid_extension = getText(683);

		emailStr=jQuery.trim(emailStr);

		if (emailStr.length==0)
		{
			alert(error_txt_enter_email);
			return false;
		}

		var emailPat=/(.+)@(.+)/;
		var specialChars="\\(\\)<>@,;:\\\\\\\"\\.\\[\\]";
		var validChars="\[^\\s" + specialChars + "\]"
		var quotedUser="(\"[^\"]*\")";
		var ipDomainPat=/^\[(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})\]$/;
		var atom=validChars + '+';
		var word="(" + atom + "|" + quotedUser + ")";
		var userPat=new RegExp("^" + word + "(\\." + word + ")*$");
		var domainPat=new RegExp("^" + atom + "(\\." + atom +")*$");
		var matchArray=emailStr.match(emailPat);
		if (matchArray==null)
		{
			alert(error_txt_invalid_form + ' (' + emailStr + ')');
			return false;
		}
		var user=matchArray[1];
		var domain=matchArray[2];

		if (user.match(userPat)==null)
		{
			alert(error_txt_username_invalid + ' (' + emailStr + ')');
			return false;
		}

		var IPArray=domain.match(ipDomainPat);
		if (IPArray!=null)
		{
			for (var i=1;i<=4;i++)
			{
				if (IPArray[i]>255)
				{
					alert(error_txt_invalid_extension + ' (' + emailStr + ')');
					return false;
				}
			}
		}

		var domainArray=domain.match(domainPat);

		if (domainArray==null)
		{
			alert(error_txt_invalid_extension + ' (' + emailStr + ')');
			return false;
		}

		var atomPat=new RegExp(atom,"g");
		var domArr=domain.match(atomPat);
		var len=domArr.length;

		if (domArr[domArr.length-1].length<2 || domArr[domArr.length-1].length>6)
		{
			alert(error_txt_invalid_extension + ' (' + emailStr + ')');
			return false;
		}

		if (len<2)
		{
			alert(error_txt_invalid_extension + ' (' + emailStr + ')');
			return false;
		}

		return true;
	  };

	  var arrayUniqueByKey = function(inArr, key){

			try{

				inputArray = $.map(inArr, function(o){
					return o[key];
				});

				var outputArray = [];

				for (var i = 0; i < inputArray.length; i++)
				{
					if ((jQuery.inArray(inputArray[i], outputArray)) == -1)
					{
						outputArray.push(inputArray[i]);
					}
				}

				return outputArray;
			}
			catch(ex){

				console.log("Error arrayUniqueByKey: " + ex);
				return inArr;

			}

	  };

	  //Palauttaa arrayn primitiivejä jotka löytyvät molemmista listoista.
	  var arrayIntersect = function(array1, array2){
		var res = array1.filter(function(n) {
			return array2.indexOf(n) != -1
		});

		return res;
	  };

	  return {

			arrayIntersect: arrayIntersect,

			arrayUniqueByKey: arrayUniqueByKey,

			getText: getText,

			getKieli: getKieli,

			getCSRF: getCSRF,

			getParams: getParams,

			closeDialog: closeDialog,

			mapChangeLogEvent: mapChangeLogEvent,

			isInteger: isInteger,

			isiPhone: function(){

				return (
					//Detect iPhone
					(navigator.platform.indexOf("iPhone") != -1) ||
					//Detect iPod
					(navigator.platform.indexOf("iPod") != -1) ||
					//Detect iPad
					(navigator.platform.indexOf("iPad") != -1)
				);
			},

			isDevelopment : function(){

				var href = window.location.href;

				return (href.indexOf("prislocal") > 0 ||
						href.indexOf("prisdev") > 0);
			},

			isIE: function(){
				if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
				   return true;
				}
				else{
					return false;
				}
			},

			isEdge: function() {

				return navigator.userAgent.indexOf('Edge/') !== -1;

			},

			mailSupport: function(inId, inError_Type, url, ctoken)
			{
				return CommonAjax.post("LAHETA_VIRHEESTA_SAHKOPOSTI", false, {
					virhe_id: inId,
					virhe_tyyppi: inError_Type,
					ctoken: ctoken,
					url: url,
					dataType: "html"
				});
			},

			getInternetExplorerVersion: function()
			{
			  var rv = -1;
			  if (navigator.appName == 'Microsoft Internet Explorer')
			  {
				var ua = navigator.userAgent;
				var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
				if (re.exec(ua) != null)
				  rv = parseFloat( RegExp.$1 );
			  }
			  else if (navigator.appName == 'Netscape')
			  {
				var ua = navigator.userAgent;
				var re  = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
				if (re.exec(ua) != null)
				  rv = parseFloat( RegExp.$1 );
			  }
			  return rv;
			},

			isIE_lessthan: function(version){
				if(this.isIE()){
					var myNav = navigator.userAgent.toLowerCase();
					var browser_version = this.getInternetExplorerVersion();

					if(browser_version < version){
						return true;
					}
					else{
						return false;
					}
				}
				else{
					return false;
				}
			},

			isSafari: function() {
				if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
					return true;
				}
				else{
					return false;
				}
			},

			isChrome: function() {

				return navigator.userAgent.indexOf('Chrome') !== -1;

			},

			isFirefox: function() {
				if(navigator.userAgent.toLowerCase().indexOf('firefox') != -1){
					return true;
				}
				else{
					return false;
				}
			},

			hasTifSupport: function(){

				return (this.isEdge() || this.isIE() || this.isSafari());

			},

			//Validoidaan sähköpostiosoite
			validateEmail: function(emailStr, lang, csrf, pid)
			{
				var d = new $.Deferred;
				var self = this;

				lang == (lang && lang.length > 0 ? lang : pParams.Kieli);

				if(csrf && csrf.length > 0)
					pParams.CSRF = csrf;

				if(pid && pid.length > 0)
					pParams.PID = pid;

				if(texts[2114] === undefined ||
					texts[680] === undefined ||
					texts[682] === undefined ||
					texts[683] === undefined){

					this.init_texts(lang, "2114,680,682,683").done(function(){
						d.resolve(checkEmail(emailStr));
					});
				}
				else{
					d.resolve(checkEmail(emailStr));
				}

				return d.promise();
			},

			//Avataan ikkuna keskelle näyttöä.
			//Jos viimeinen parametri name on eri kuin undefined annetaan ikkunalle nimi
			//ikkunan nimi tarvitaan jos siihen pitää viitata jälikäteen.
			openWindow: function (url,inC,width,height, name) {

				//Jos annettu korkeus on isompi kuin näytön korkeus, on pienennettävä height parametria
				if(height > screen.availHeight){
					var oldHeight = height;
					height = (screen.availHeight - 120);

					if(window.console){
						console.log("Changed window height from: " + oldHeight + " to height: " + height);
					}
				}

				//Jos annettu leveys on isompi kuin näytön leveys, on pienennettävä width parametria
				if(width > screen.availWidth){
					var oldWidth = width;
					width = (screen.availWidth - 120);

					if(window.console){
						console.log("Changed window width from: " + oldWidth + " to height: " + width);
					}
				}

				var left = parseInt((screen.availWidth/2) - (width/2));
				var top = parseInt((screen.availHeight/2) - (height/2));
				inC = inC + ",width=" + width + ",height=" + height + ",left=" + left + ",top=" + top + "screenX=" + left + ",screenY=" + top;

				var n = (name && name.length > 0 ? name : "");

				var w = window.open(url,n,inC);
				w.focus();

				closeDialog();

				return w;
			},


			init_params : function(inParams, do_text_init, options){

				var d = new $.Deferred;

				//Kopioidaan parametrit
				for (var prop in inParams) {
					if (inParams.hasOwnProperty(prop)) {
						pParams[prop] = inParams[prop];
					}
				}

				if(do_text_init){
					return this.init_texts(pParams.Kieli, pParams.texts, options);
				}
				else{
					return d.resolve();
				}
			},

			init_texts : function(kieli, commaSeparatedTexts, options){

				commaSeparatedTexts = (commaSeparatedTexts && commaSeparatedTexts.length > 0 ? commaSeparatedTexts : textsToFetch);

				//Jossain tilanteissa voi olla ettei löydy CSRF tokenia, ja pitää hakea sanastosta tekstejä. GET:llä onnistuu ilman tokenia.
				if(options && options.init_method === "GET"){
					return CommonAjax.fetch("HAE_SANASTON_TEKSTIT", {
						tekstit: commaSeparatedTexts,
						Kieli: kieli,
						url: (options.url ? options.url : undefined),
						dataType: "json"
					}).done(function(data){
						for(var i = 0; i < data.length; i++){
							texts[data[i].id] = { id: data[i].id, text: data[i].text };
						}

						text_init_done = true;
					});
				}
				else{
					return CommonAjax.post("HAE_SANASTON_TEKSTIT", true, {
						tekstit: commaSeparatedTexts,
						Kieli: kieli,
						dataType: "json"

					}).done(function(data){

						for(var i = 0; i < data.length; i++){
							texts[data[i].id] = { id: data[i].id, text: data[i].text };
						}

						text_init_done = true;
					});
				}
			},

			get_additional_params: function(){

				return $.ajax({

					type: "POST",
					dataType: "json",
					url: "../lib/libAjaxFuncs.asp",
					data: {
						Func:"hae_lisa_asetukset",
						PID: pParams.PID,
						UID: pParams.UID,
						ctoken: pParams.CSRF,
						Dummy: new Date()
					},
					success: function(data) {
					},
					error: function (xhr, ajaxOptions, thrownError) {
					}
				});
			},

			getDialog: function(target_element, params){
				closeDialog(target_element);

				if($(".ui-dialog-buttonpane").find(".asetukset_koko").length > 0){
					$(".ui-dialog-buttonpane").find(".asetukset_koko").remove();
				}

				var ds = "no dialog content defined";
				var pos = {};
				var buttons = [];

				if(params.pos){
					pos = params.pos;
				}
				else{
					pos = { my: "center top", at: "center top"};
				}

				if(params.content && params.content.length > 0){
					ds = params.content;
				}

				if(params.buttons && $.isArray(params.buttons)){
					buttons = params.buttons;
				}
				else{
					buttons = [
						{
							text: getText(1092),
							click: function() {
								$(this).dialog('close');
							}
						}
					];
				}

				// Dialog
				$(target_element).html(ds).dialog({

					title:(params.title && params.title.length > 0 ? params.title : "ei otsikkoa"),
					dialogClass: "no-close",
					closeOnEscape: true,
					autoOpen: false,
					width: (params.width && parseInt(params.width) > 0 ? params.width : 450),
					height: (params.height && parseInt(params.height) > 0 ? params.height : 500),
					modal: (params.modal ? params.modal : true),
					position: pos,
					buttons: buttons,
					open: function() {
						$("#dialog").off();

						$("#dialog").keypress(function(e) {
						  if(e.target.tagName.toUpperCase() !== "TEXTAREA"){
							  if (e.keyCode == $.ui.keyCode.ENTER) {
								$(this).parent().find('.ui-dialog-buttonset button').eq(0).trigger("click");
							  }
						  }
						});
					}
				});

				$(target_element).dialog('open');

				return false;
			},

			aseta_halytysrajat: function(koko_kb, target_element){

				$(".ui-dialog-buttonpane").find(".asetukset_koko").remove();

				Ajax.fetch("HAE_PROJEKTIKOKO_HALYTYS", {
					"PID" : pParams.PID
				}).done(function(r){

					var enabled = false;
					var receivers = "";
					var alarmevery;

					var project_size_kb = koko_kb;
					var project_size_mb = 0;
					var project_size_gb = 0;
					var next_project_size_gb = 0;

					if(project_size_kb >= 1024){
						project_size_mb = (project_size_kb / 1024);

						if(project_size_mb >= 1024){
							project_size_gb = (project_size_mb / 1024);
						}
					}

					next_project_size_gb = Math.round(project_size_gb + 1);

					if(r.length > 0){

						r = r[0];

						if(r.receivers && r.receivers.length > 0){
							receivers = r.receivers;
						}

						if(r.alarmwhengb){
							next_project_size_gb = r.alarmwhengb;
						}

						if(r.alarmeverygb){
							alarmevery = r.alarmeverygb;

						}

						if(r.alarmenabled){
							enabled = (parseInt(r.alarmenabled) === 1 ? true : false);
						}
					}

					if(target_element.indexOf("#") === -1){
						target_element = "#" + target_element;
					}

					var ds = "<br />";

					ds += getText(2143);

					ds += "<br />";
					ds += "<br />";

					ds += "<input type='checkbox' name='chk_alarm_enabled' id='chk_alarm_enabled' " + (enabled ? "CHECKED" : "") + "/>&nbsp;" + getText(2148);
					ds += "<br /><br />";

					ds += "<table>";

					ds += "<tr>";
					ds += "<td>";
					ds += getText(2144);
					ds += "</td>";
					ds += "<td>";
					ds += "<input type='text' name='alarmto' id='alarmto' class='initial_dis' " + (!enabled ? "DISABLED" : "") + " style='width: 200px;' value='" + receivers + "' />";
					ds += "</td>";
					ds += "</tr>";

					ds += "<tr>";
					ds += "<td>";
					ds += getText(2145);
					ds += "</td>";
					ds += "<td>";
					ds += "<input type='text' name='when_exceeds' " + (!enabled ? "DISABLED" : "") + " class='initial_dis' id='when_exceeds' style='width: 50px;' value='" + next_project_size_gb + "'/>";
					ds += "&nbsp;"
					ds += "GB";
					ds += "</td>";
					ds += "</tr>";

					ds += "<tr>";
					ds += "<td>";
					ds += "<input style='vertical-align: top;' " + (!enabled ? "DISABLED" : "") + " class='initial_dis' type='checkbox' name='chk_send_every' id='chk_send_every' " + (alarmevery && enabled ? "CHECKED" : "") + "/>";
					ds += getText(2146);
					ds += "</td>";
					ds += "<td>"
					ds += "<input type='text' class='initial_dis' name='txt_send_every' id='txt_send_every' " + (!enabled ? "DISABLED" : "") + " style='width: 50px;' value='" + (alarmevery !== undefined ? alarmevery : '') + "' />";
					ds += "&nbsp;"
					ds += "GB";

					if(pParams.Kieli == '_fi'){
						ds += "&nbsp;";
						ds += getText(2147);
					}
					ds += "</td>";
					ds += "</tr>";

					ds += "</table>";

					$(target_element).html(ds).dialog({

							title:getText(2142),
							dialogClass: "no-close",
							closeOnEscape: true,
							autoOpen: false,
							width: 450,
							height: 500,
							modal: false,
							position: { my: "center top", at: "center top"},
							buttons: [
								{
									text: getText(54),
									click: function() {

										var alarmto = $("#alarmto").val();
										var when_exceeds = $("#when_exceeds").val();
										var send_every;

										if($("#chk_send_every").prop("checked")){
											send_every = $("#txt_send_every").val();

											if(send_every.length === 0){
												alert(getText(2154));
												$("#txt_send_every").css("color", "red");
												return false;
											}
										}
										else{
											send_every = "";
										}

										if($.trim(alarmto).length > 0){
											var alarmto = alarmto.replace(/,/g, ";");

											var emails = alarmto.split(";");

											var errors = 0;
											var d = new $.Deferred;
											var deferredDones = 0;

											for(var k = 0; k < emails.length; k++){

												var emailAddr = $.trim(emails[k]);

												if(emailAddr.length > 0){

													Common.validateEmail(emailAddr, pParams.Kieli, pParams.CSRF, pParams.PID).done(function(returnCode){

														if(!returnCode){
															d.resolve(false);
															errors++;
														}

														if(deferredDones == (emails.length - 1)){
															d.resolve(!(errors > 0));
														}

														deferredDones++;
													});

												}

												if(errors > 0){
													break;
												}
											}
										}
										else{
											if($("#chk_alarm_enabled").prop("checked") === true){
												alert(getText(485));
												return false;
											}

											var d = new $.Deferred;
											d.resolve(true);
										}

										d.done(function(returncode){

											if(errors > 0){
												return false;
											}

											if(!Common.isInteger(when_exceeds)){
												alert(getText(2153));
												$("#when_exceeds").css("color", "red");
												return false;
											}

											if($("#txt_send_every").val().length > 0){
												if(!Common.isInteger(send_every)){
													alert(getText(2153));
													$("#txt_send_every").css("color", "red");
													return false;
												}
											}

											Ajax.post("TALLENNA_PROJEKTIKOKO_HALYTYS", true, {
												PID: pParams.PID,
												UID: pParams.UID,
												JulkaisuID: pParams.JulkaisuID,
												Receivers: alarmto,
												when_exceeds: when_exceeds,
												send_every: send_every,
												enabled: ($("#chk_alarm_enabled").prop("checked") ? 1 : 0)

											}).done(function(resp){

												closeDialog();

											});

										});
									}
								},
								{
									text: getText(1092),
									click: function() {
										$(this).dialog('close');
									}
								}
							]
					});

					$(target_element).find("#alarmto").focus();

					$(target_element).find("#alarmto").autocomplete({
						source: "../lib/libAjaxFuncs.asp?func=hae_paakayttajat&PID=" + pParams.PID,
						minLength: 2,
						multiple: true
					});

					$(target_element).find("#chk_alarm_enabled").click(function(){
						$(".initial_dis").prop("disabled", !$(this).prop("checked"));
					});

					$(target_element).find("#chk_send_every").click(function(){
						if($(this).is(":checked")){
							$("#txt_send_every").prop("disabled", false);
						}
						else{
							$("#txt_send_every").prop("disabled", true);
						}
					});

					$(target_element).keypress(function(e) {
					  if (e.keyCode == $.ui.keyCode.ENTER) {
						$(this).parent().find("button:eq(0)").trigger("click");
					  }
					});

				});

			},

			avaa_asetukset_ikkuna : function(target_element){

				if(!gDependenciesLoaded){
					console.warn("Sorry, dependencies could not be loaded in time.");
				}

				closeDialog(target_element);

				var ds = "";

				this.get_additional_params().done(function(d){

					d = d[0];

					pParams.Admin = (d.admin == null ? 0 : d.admin);
					pParams.OrgAdmin = (d.orgadmin == null ? 0 : d.orgadmin);
					pParams.JulkaisuID = (d.julkaisuid == null ? 0 : d.julkaisuid);
					pParams.onkoKohde = (d.onkokohde == null ? 0 : d.onkokohde);

					var admin = parseInt(pParams.Admin);
					var orgAdmin = parseInt(pParams.OrgAdmin);
					var koko_kb = (d.koko_kb == null ? 0 : d.koko_kb);

					ds += '<div class="asetukset_menu">';
					ds += '<ul class="asetukset_list">';
					ds += '<li class="asetukset_divider"></li>';
					ds += '<li><a href="#" onclick="Common.openWindow(\'../Projektit/NaytaTiedot.asp?PID=' + pParams.PID + '&vainTiedot=1' + '\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',800,583, \'NaytaTiedot\');">' + getText(120) + '</a></li>';
					ds += '<li><a href="#" onclick="Common.openWindow(\'../Main/Omattiedot.asp?PID=' + pParams.PID + '&ID=' + pParams.UID + '\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',800,700, \'NaytaTiedot\');">' + getText(218) + '</a></li>';
					ds += '<li class="' + (pParams.PID == 8717 && (orgAdmin != 1 && admin != 1) ? "disabled" : "") + '"><a href="#" onclick="Common.openWindow(\'../Projektit/NaytaTiedot.asp?PID=' + pParams.PID + '&vainOsapuolet=1' + '\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',900,700, \'NaytaTiedot\');">' + getText(2100) + '</a></li>';
					ds += '<li class="asetukset_divider"></li>';

					if(pParams.onkoKohde === 1){
						ds += '<li class="' + (orgAdmin === 1 || admin === 1 ? "" : "disabled") + '"><a href="#" onclick="' + (orgAdmin === 1 || admin === 1 ? "" : "return false;") + 'Common.openWindow(\'../Projektit/KayttoOikeudet.asp?is_kohde=1&PID=' + pParams.PID + '\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',800,700, \'NaytaTiedot\');">' + getText(608) + '</a></li>';
					}
					else{
						ds += '<li class="' + (orgAdmin === 1 || admin === 1 ? "" : "disabled") + '"><a href="#" onclick="' + (orgAdmin === 1 || admin === 1 ? "" : "return false;") + 'Common.openWindow(\'../Projektit/KayttoOikeudet.asp?PID=' + pParams.PID + '\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',800,700, \'NaytaTiedot\');">' + getText(608) + '</a></li>';
					}

					ds += '<li class="' + (orgAdmin === 1 || admin === 1 ? "" : "disabled") + '"><a href="#" onclick="' + (orgAdmin === 1 || admin === 1 ? "" : "return false;") + 'Common.openWindow(\'../Projektit/LisaaKayttaja.asp?PID=' + pParams.PID + '\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',800,700, \'NaytaTiedot\');">' + getText(670) + '</a></li>';

					ds += '<li class="' + (orgAdmin === 1 ? "" : "disabled") + '"><a href="#" onclick="' + (orgAdmin === 1 ? "" : "return false;") + 'Common.openWindow(\'../Projektit/KayttoOikeudet_Org.asp?PID=' + pParams.PID + '\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',800,700, \'NaytaTiedot\');">' + getText(1992) + '</a></li>';
					//ds += '<li class="' + (orgAdmin === 1 || admin === 1 ? "" : "disabled") + '"><a href="#" onclick="' + (orgAdmin === 1 || admin === 1 ? "" : "return false;") + 'Common.openWindow(\'../Main/SessionTransfer.asp?dir=2aspx&url=OrganisaatioAsetukset.aspx&Asetukset=1&PID=' + pParams.PID + '\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',1280,1024, \'Asetukset\');">' + getText(638) + '</a></li>';

					ds += '<li class="asetukset_divider"></li>';
					ds += '<li class="' + (orgAdmin === 1 || admin === 1 ? "" : "disabled") + '"><a href="#" onclick="' + (orgAdmin === 1 || admin === 1 ? "" : "return false;") + 'Common.openWindow(\'../Projektit/MaaritteleKopiolaitos.asp?PID=' + pParams.PID + '\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',800,700, \'NaytaTiedot\');">' + getText(2101) + '</a></li>';
					ds += '<li class="' + (orgAdmin === 1 || admin === 1 ? "" : "disabled") + '"><a href="#" onclick="' + (orgAdmin === 1 || admin === 1 ? "" : "return false;") + 'Common.openWindow(\'../Main/SessionTransfer.asp?dir=2aspx&url=Rakenne.aspx&Rakenne=1&PID=' + pParams.PID + '\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',1280,1024, \'Rakenne\');">' + getText(2102) + '</a></li>';//2102

					// Käyttöoikeusprofiilit
					ds += '<li class="' + (orgAdmin === 1 || admin === 1 ? "" : "disabled") + '"><a href="#" onclick="' + (orgAdmin === 1 || admin === 1 ? "" : "return false;") + 'Common.openWindow(\'../Main/SessionTransfer.asp?dir=2aspx&url=Kayttooikeusprofiilit.aspx&Rakenne=1&PID=' + pParams.PID +'\', \'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no\',1280,1024, \'Rakenne\');">' + getText(2223) + '</a></li>';

					ds += '</ul>';
					ds += '</div>';

					// Dialog
					$(target_element).html(ds).dialog({

						title:getText(2099),
						dialogClass: "no-close",
						closeOnEscape: true,
						autoOpen: false,
						width: 450,
						height: 500,
						modal: false,
						position: { my: "center top", at: "center top"},
						buttons: [
							{
								text: getText(1092),
								click: function() {
									$(this).dialog('close');
								}
							}
						]
					});

					$(target_element).dialog('open');

					if(orgAdmin === 1 || admin === 1){

						var divKoko = "<div class='asetukset_koko'>";

						var koko_txt = getText(1577);
						var aseta_txt = getText(2142);
						var project_size_txt = getText(2342);

						if(koko_txt.indexOf("(") !== -1){
							koko_txt = koko_txt.substring(0, koko_txt.indexOf("(")-1);
						}

						divKoko += koko_txt + ": ";

						if(parseInt(koko_kb) >= 1024){

							var koko_mb = koko_kb / 1024;

							if(parseInt(koko_mb) >= 1024){

								var koko_gb = koko_mb / 1024;

								divKoko += "<span class='size'>" + parseFloat(koko_gb).toFixed(2) + " GB</span>";

							}
							else{
								divKoko += "<span class='size'>" + parseFloat(koko_mb).toFixed(2) + " MB</span>";
							}
						}
						else{
							divKoko += "<span class='size'>" + parseFloat(koko_kb).toFixed(2) + " KB</span>";
						}

						divKoko += "&nbsp";
						divKoko += '<img src="../images/information.png" id="tip_project_size" class="tippable" data-comment="' + project_size_txt + '" style="border: none; cursor: pointer;" title="Haku"/>';

						divKoko += "<br />";

						divKoko += "<a style='color: steelblue; cursor: pointer;' onclick='Common.aseta_halytysrajat(" + koko_kb + ", \"" + $(target_element).prop("id") + "\");' title='" + aseta_txt + "'>";
						divKoko += "&gt;&gt;&nbsp;" + aseta_txt;
						divKoko += "</a>";

						divKoko += "</div>";

						$(".ui-dialog-buttonpane").find(".asetukset_koko").remove();
						$(".ui-dialog-buttonpane").append(divKoko);

					}

					$(target_element).find("a").blur();

					$(".tippable").tooltip({
						items: '[data-comment]',
						content: function() {
							return $( this ).data('comment');
						}
					});

					return false;

				});

		  },

		  parseUudetOminaisuudetXml : function(xml, inKieli, tulostaLista, container)
	      {
			  var items = [];
			  var appended = 0;

			  $(xml).find("Julkaisu").each(function()
			  {
					var pvm = $(this).attr("pvm");
					var kieli = $(this).attr("Kieli");
					var nakyvissa = $(this).attr("Nakyvissa");
					var selKieli = inKieli;

					if(tulostaLista){

						if(parseInt(nakyvissa) === 1 && kieli.toLowerCase() == selKieli.toLowerCase()){

							var otsikko = $(this).find("Otsikko").text();
							var content = $(this).find("SisaltoHTML").text();

							var header = "<h3>" + pvm + "</h3>";

							var ominaisuus = "<div>";
							ominaisuus += header;
							ominaisuus += content;
							ominaisuus += "</div>";

							$(container).append(ominaisuus);

							//$(container).append("<br />");

							appended++;

							items.push({pvm: pvm, kieli: kieli, nakyvissa: nakyvissa });
						}
					}
					else{

						if(parseInt(nakyvissa) === 1 && kieli.toLowerCase() == selKieli.toLowerCase()){

							items.push({pvm: pvm, kieli: kieli, nakyvissa: nakyvissa });

						}
					}
			  });

			  if((items.length === 0 || appended === 0) && inKieli != "_en"){
					return this.parseUudetOminaisuudetXml(xml, "_en", tulostaLista, container);
			  }

			  return items;
		   },
		   preview: function(data)
		   {
				var ie_version = 0;

				if(data.type === "pdf"){
					if(Common.isIE_lessthan(10)){
						ie_version = Common.getInternetExplorerVersion();

						var txt_preview_support = data.texts.preview_support;

						txt_preview_support = txt_preview_support.replace("{0}", ie_version);

						toastr.warning("", txt_preview_support);
						return false;
					}

					var lang = data.kieli

					lang = lang.substring(1);

					var viewerUrl = "/javascript/pdf.js/web/viewer.html?locale=" + lang + "&file=";
					var pdfUrl = "//" + data.misc.GCPRISUrl + "/Main/HaeAsiakirja.asp?Tiedosto=" + data.aid;

					Common.openWindow(viewerUrl + encodeURIComponent(pdfUrl),'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no','1200','700', 'Preview');
				}
				else if(data.type === "image"){

					var galleryType = data.gallerytype;

					if(galleryType.length === 0){
						galleryType = "photoswipe";
					}

					var viewerUrl = "";

					switch(galleryType){

						case "photoswipe":
							viewerUrl = "/Main/preview.asp?tiedosto=" + data.aid + "&parentid=" + data.parentid;
							break;
						case "galleria":
							if(data.suunnittelualaid && data.suunnittelualaid.length > 0){
								viewerUrl = "/Main/galleria.asp?tiedosto=" + data.aid + "&suunnittelualaid=" + data.suunnittelualaid;
							}
							else if(data.kori && data.kori.length > 0){
								viewerUrl = "/Main/galleria.asp?tiedosto=" + data.aid + "&kori=" + encodeURIComponent(data.kori) + "&PID=" + data.pid;
							}
							else{
								viewerUrl = "/Main/galleria.asp?tiedosto=" + data.aid + "&parentid=" + data.parentid + "&ryhma=" + encodeURIComponent(data.ryhma);
							}
							break;
						default:
							viewerUrl = "/Main/preview.asp?tiedosto=" + data.aid + "&parentid=" + data.parentid;
							break;
					}

					Common.openWindow(viewerUrl, 'toolbar=no,location=no,directories=no,status=yes,scrollbars=yes,resizable=yes,copyhistory=no','1200','700', 'Preview');

				}
			}
	 }
	})();

	Colors = {};
    Colors.names = {
        beige: { hex:"#f5f5dc", order: 999 },
        black: { hex:"#000000", order: 5 },
        blue: { hex:"#0000ff", order: 1 },
        brown: { hex:"#a52a2a", order: 999 },
        cyan: { hex:"#00ffff", order: 999 },
        darkblue: { hex:"#00008b", order: 999 },
        darkcyan: { hex:"#008b8b", order: 7 },
        darkgrey: { hex:"#a9a9a9", order: 999 },
        darkgreen: { hex:"#006400", order: 999 },
        darkkhaki: { hex:"#bdb76b", order: 999 },
        darkmagenta: { hex:"#8b008b", order: 3 },
        darkolivegreen: { hex:"#556b2f", order: 999 },
        darkorange: { hex:"#ff8c00", order: 9 },
        darkorchid: { hex:"#9932cc", order: 999 },
        darkred: { hex:"#8b0000", order: 999 },
        darksalmon: { hex:"#e9967a", order: 999 },
        darkviolet: { hex:"#9400d3", order: 999 },
        gold: { hex:"#ffd700", order: 999 },
        green: { hex:"#008000", order: 999 },
        indigo: { hex:"#4b0082", order: 999 },
        khaki: { hex:"#f0e68c", order: 999 },
        lime: { hex:"#00ff00", order: 2 },
        magenta: { hex:"#ff00ff", order: 10 },
        maroon: { hex:"#800000", order: 999 },
        navy: { hex:"#000080", order: 8 },
        olive: { hex:"#808000", order: 999 },
        orange: { hex:"#ffa500", order: 999 },
        pink: { hex:"#ffc0cb", order: 999 },
        violet: { hex:"#800080", order: 999 },
        red: { hex:"#ff0000", order: 4 },
        yellow: { hex:"#ffff00", order: 6 }
    };
    Colors.random = function() {
        var result;
        var count = 0;
        for (var prop in this.names)
            if (Math.random() < 1/++count)
               result = prop;
        return { name: result, rgb: this.names[result].hex};
    };
    Colors.getSorted = function() {
    	var colorsArr = [];

	    colorsArr = Object.keys(Colors.names).map(function(key) {
	      return Colors.names[key];
	    });

	    var sortedColors = colorsArr.sort(function(a, b) {
	        var prop = "order";
	        if (typeof a[prop] == "number") {
	            return (a[prop] - b[prop]);
	        } else {
	            return ((a[prop] < b[prop]) ? -1 : ((a[prop] > b[prop]) ? 1 : 0));
	        }
	    });

	    return sortedColors;
    }

})(jQuery);
